<template>
  <BoardView :title="$t('title')">
    <FormValidation @submit="create">
      <FormSite :site.sync="site" type="new" />
      <Btn v-if="hasRole('>=MODERATOR')" class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardAdd from '@mixins/BoardAdd'
import FormSite from '@forms/FormSite'

export default {
  mixins: [BoardAdd('site', {
    role: 'MODERATOR',
    factory() {
      return {
        siteUsers: [
          { userId: this.$store.getters.authUser.id },
        ],
      }
    },
    redirectTo: 'Sites',
  })],
  components: { FormSite },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Save",
    "title": "Add site"
  }
}
</i18n>
